import { entries, values, mapValues, isNil, isArray, isPlainObject } from 'gleam-shared/helpers/nodash'

export function mapValuesDeep(input, iteratee) {
  if (isNil(input)) {
    return {}
  }

  if (!isArray(input) && !isPlainObject(input)) {
    console.warn(`mapValuesDeep: unintended use with ${input}`)
    return {}
  }

  if (!iteratee) {
    return input
  }

  return iterateValuesDeep(input, iteratee)
}

function iterateValuesDeep(input, iteratee, key, parent) {
  if (isArray(input) || isPlainObject(input)) {
    return mapValues(input, (value, key) => {
      return iterateValuesDeep(value, iteratee, key, input)
    })
  } else {
    return iteratee(input, key, parent)
  }
}

export function valuesDeep(input) {
  if (isNil(input)) {
    return []
  }

  if (!isArray(input) && !isPlainObject(input)) {
    console.warn(`valuesDeep: unintended use with ${input}`)
    return []
  }

  return walkValuesDeep(input)
}

function walkValuesDeep(input) {
  if (isArray(input)) {
    return input.flatMap(walkValuesDeep)
  } else if (isPlainObject(input)) {
    return values(input).flatMap(walkValuesDeep)
  } else {
    return [input]
  }
}

export function entriesDeep(input) {
  if (isNil(input)) {
    return []
  }

  if (!isArray(input) && !isPlainObject(input)) {
    console.warn(`valuesDeep: unintended use with ${input}`)
    return []
  }

  return walkEntriesDeep(input)
}

function walkEntriesDeep(input, parent = '') {
  if (isArray(input)) {
    return input.flatMap((value, index) => {
      return walkEntriesDeep(value, joinIndex(parent, index))
    })
  } else if (isPlainObject(input)) {
    return entries(input).flatMap(([key, value]) => {
      return walkEntriesDeep(value, joinKey(parent, key))
    })
  } else {
    return [[parent, input]]
  }
}

function joinIndex(parent, index) {
  return `${parent}[${index}]`
}

function joinKey(parent, key) {
  if (parent.length === 0) {
    return key
  } else {
    return `${parent}.${key}`
  }
}
